import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ASSET_BASE = BACKEND_URL;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("csr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      // Don't auto-redirect during login attempt
      if (!error.config?.url?.includes("/auth/login")) {
        localStorage.removeItem("csr_token");
        localStorage.removeItem("csr_user");
      }
    }
    return Promise.reject(error);
  },
);

export function assetUrl(p) {
  if (!p) return "";
  if (p.startsWith("http") || p.startsWith("blob:")) return p;
  // Normalize to a leading slash so rows stored as "uploads/..." also resolve
  let path = p.startsWith("/") ? p : `/${p}`;
  if (path.startsWith("/api/uploads")) return `${ASSET_BASE}${path}`;
  if (path.startsWith("/uploads")) return `${ASSET_BASE}/api${path}`;
  return p;
}

// Forces a file download (attachment) regardless of type — images open inline otherwise.
export function downloadUrl(storedPath, name) {
  if (!storedPath) return "";
  const q = new URLSearchParams({ path: storedPath });
  if (name) q.set("name", name);
  return `${API}/download?${q.toString()}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
